import { Injectable } from '@angular/core';
import {
  NGXLogger,
  NgxLoggerLevel,
  NGXLoggerMonitor,
  NGXLogInterface
} from 'ngx-logger';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  env: string;
  canDebug: boolean;

  constructor(private logger: NGXLogger) {
    // TRACE|DEBUG|INFO|LOG|WARN|ERROR|FATAL|OFF
    this.env = environment.type;
    this.canDebug =
      environment.type === 'local' ||
      environment.type === 'dev' ||
      environment.type === 'qa' ||
      environment.type === 'beta';
    console.log(
      'The environment: ',
      this.env,
      ', has debugging enabled ',
      this.canDebug
    );

    this.logger.registerMonitor(new MyLoggerMonitor());

    if (this.canDebug) {
      console.log('debug mode ON');
      this.logger.updateConfig({ level: NgxLoggerLevel.TRACE });
    } else {
      this.logger.updateConfig({ level: NgxLoggerLevel.OFF });
    }
  }

  sendTraceLevelMessage(message, source, error) {
    this.logger.trace(message, source, error);
  }

  sendDebugLevelMessage(message, source, error) {
    this.logger.debug(message, source, error);
  }

  sendInfoLevelMessage(message) {
    this.logger.info(message);
  }

  sendLogLevelMessage(message, source, error) {
    this.logger.log(message, source, error);
  }

  sendWarnLevelMessage(message, error) {
    this.logger.warn(message, error);
  }

  sendErrorLevelMessage(message, source, error) {
    this.logger.error(message, source, error);
  }

  sendFatalLevelMessage(message, source, error) {
    this.logger.fatal(message, source, error);
  }
}

export class MyLoggerMonitor implements NGXLoggerMonitor {
  onLog(_logObject: NGXLogInterface): void {
    //console.log('logging:', logObject);
  }
}
